import type { StateCreator } from 'zustand/vanilla';

import type { Space } from '@/features/spaces/interfaces/space.interface';
import type { WorkspaceStore } from '../../store';

export interface WorkspaceCurrentAction {
  /**
   * Set the current space and automatically extract its ID.
   * Updates BOTH currentSpace AND currentSpaceId atomically in a single set() call.
   * This is the primary action called when a user selects or enters a space.
   */
  setCurrentSpace: (space: Space) => void;

  /**
   * Explicitly update only the current space ID.
   * Does NOT affect the full currentSpace object.
   * Use during navigation-only updates or partial rehydration.
   */
  setCurrentSpaceId: (id: string) => void;

  /**
   * Clear both currentSpace and currentSpaceId to undefined.
   * Called when a user exits a space or as part of logout cleanup.
   * After this call, all selectors derived from currentSpace return their fallback values.
   */
  clearCurrentSpace: () => void;
}

export const createCurrentSlice: StateCreator<WorkspaceStore, [['zustand/devtools', never]], [], WorkspaceCurrentAction> = (set) => ({
  setCurrentSpace: (space: Space) => {
    set({ currentSpace: space, currentSpaceId: space.id });
  },

  setCurrentSpaceId: (id: string) => {
    set({ currentSpaceId: id });
  },

  clearCurrentSpace: () => {
    set({ currentSpace: undefined, currentSpaceId: undefined });
  },
});
